export default class FullscreenApi {
    // Grabbed iPad from here: https://developer.apple.com/documentation/webkitjs/htmlvideoelement/1633500-webkitenterfullscreen
    private static fullscreenFunctionNames: string[] = [
        'requestFullscreen',
        'requestFullScreen',
        'webkitRequestFullscreen',
        'webkitRequestFullScreen',
        'webkitEnterFullscreen', // iPad
        'msRequestFullscreen',
        'msRequestFullScreen',
        'mozRequestFullScreen',
        'mozRequestFullscreen'
    ];
    private static cancelFullscreenFunctionNames: string[] = [
        'cancelFullScreen',
        'exitFullscreen',
        'webkitCancelFullScreen',
        'webkitExitFullscreen',
        'msCancelFullScreen',
        'msExitFullscreen',
        'mozCancelFullScreen',
        'mozExitFullscreen'
    ];
    private static fullScreenValues = [
        "fullscreen",
        "mozFullScreen",
        "webkitIsFullScreen",
        "msFullscreenElement"
    ];

    public static RequestFullscreen(element: HTMLElement): void {
        var func = this.fullscreenFunctionNames.filter(x => element[x] != null).filter(x => x).shift();
        if (func == null) {
            console.error("Fullscreen mode is not supported on this browser");
            return;
        }
        element[func]();
    }

    public static CancelFullscreen(): void {
        var func = this.cancelFullscreenFunctionNames.filter(x => document[x] != null).filter(x => x).shift();
        if (func == null) {
            console.error("Fullscreen mode is not supported on this browser");
            return;
        }
        document[func]();
    }

    public static GetFullscreenValue(): boolean {
        var func = this.fullScreenValues.filter(x => document[x] != null).filter(x => x).shift();
        if (func == null) {
            // We might break the browser if we error on every render frame
            // console.error("Fullscreen mode is not supported on this browser");
            return false;
        }
        return document[func];
    }
}



// WEBPACK FOOTER //
// ./src/utils/FullscreenHelper.ts